import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useSpaceStatusBadgeStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    height: '1.375rem',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    paddingTop: '0.125rem',
    paddingBottom: '0.125rem',
    borderRadius: '624.9375rem',
    fontSize: fontScale.caption,
    fontWeight: 600,
    lineHeight: '1',
    whiteSpace: 'nowrap',
  },

  recommended: {
    backgroundColor: tokens.colorNeutralBackground4,
    color: tokens.colorNeutralForeground3,
  },

  available: {
    backgroundColor: tokens.colorPaletteGreenBackground3,
    color: tokens.colorNeutralForegroundOnBrand,
  },

  booked: {
    backgroundColor: tokens.colorPaletteRedBackground3,
    color: tokens.colorNeutralForegroundOnBrand,
  },

  /**
   * Figma 2026 available pill (soft green tint, dark green text). Opt-in via
   * layout consumer.
   */
  figmaAvailable: {
    backgroundColor: tokens.colorPaletteGreenBackground1,
    color: tokens.colorPaletteGreenForeground1,
  },

  /** Figma 2026 booked pill: neutral submitted palette. */
  figmaBooked: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground2,
  },

  /** Figma 2026 recommended pill: warm tint (Fluent marigold palette). */
  figmaRecommended: {
    backgroundColor: tokens.colorPaletteMarigoldBackground2,
    color: tokens.colorPaletteMarigoldForeground2,
  },

  starIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: tokens.colorPaletteYellowForeground1,
  },

  infoIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: tokens.colorNeutralForegroundOnBrand,
  },

  interactive: {
    cursor: 'pointer',
  },
});
